import { innerSearch } from 'api/Api';
import LoadingIndicator from 'app/components/LoadingIndicator';
import LoadingText from 'app/components/LoadingText';
import PayverseDirectHeader from 'app/components/PayverseDirectHeader';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

interface ReturnForm {
  resultStatus: string;
  resultMessage: string;
  resultCode: string;
  tid: string;
  orderId: string;
  mallReserved: string;
}

const DirectDebiaQRPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const { setPaymentState } = usePaymentState();

  const [tid, setTid] = useState<string>('');

  // InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(tid), {
    onSuccess: data => {
      // Data Set
      const returnUrl = data.data.returnUrl;
      const payType = String(data.data.display.payType).toLowerCase();
      // ResultForm Set
      const resultForm = {
        resultStatus: data.data.response.resultStatus,
        resultMessage: data.data.response.resultMessage,
        resultCode: data.data.response.resultCode,
        tid: data.data.response.tid,
        orderId: data.data.response.orderId,
        mallReserved: data.data.response.mallReserved,
      };
      // 상태코드 예외처리
      if (
        data.data.response.resultStatus === null ||
        data.data.response.resultStatus === undefined
      ) {
        navigate('/error');
      }
      if (
        (String(resultForm.resultStatus).toLowerCase() === 'pending' &&
          payType !== 'vbank') ||
        (String(resultForm.resultStatus).toLowerCase() === 'pending' &&
          payType !== 'otc')
      ) {
        navigate('/directPending');
      } else {
        createFormAndSubmit(resultForm, returnUrl);
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  useEffect(() => {
    const browserTypeJson = (lang: string) => {
      switch (lang) {
        case 'zh-TW':
          return 'cntr';
        case 'zh-CN':
          return 'cnsi';
        case 'en-US':
          return 'en';
        case 'ko':
          return 'ko';
        case 'ko-KR':
          return 'ko';
        case 'ja':
          return 'jp';
        default:
          return '';
      }
    };
    const userLanguage = navigator.language;
    const browserLanguage = browserTypeJson(userLanguage);
    if (browserLanguage !== '') {
      i18n.changeLanguage(browserLanguage);
      return;
    } else {
      i18n.changeLanguage('en');
    }
  }, []);

  useEffect(() => {
    const paramTid = new URLSearchParams(searchParams).get('tid');
    const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');

    // innerSearch를 위한 tid set
    if (paramTid) {
      setTid(paramTid);
      setPaymentState(prevState => ({ ...prevState, tid: paramTid }));
    }
    // QRUrl set
    if (paramPayUrl === null) {
      navigate('/error');
    } else {
      if (isMobile) {
        navigate(`/debiaQr?payUrl=${paramPayUrl}&tid=${paramTid}`);
      } else {
        openQRPopup(paramPayUrl, paramTid as string);
      }
    }
  }, [searchParams]);

  const createFormAndSubmit = (formData, returnUrl) => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', `${returnUrl}`);
    form.style.display = 'none';
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', String(value));
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };

  const openQRPopup = (url: string, paramTid: string) => {
    const popupWindow = window.open(
      `/directDebiaQRCode?payUrl=${url}&tid=${paramTid}`,
      '_blank',
      'width=700,height=650',
    );

    if (popupWindow) {
      const checkPopupClosed = setInterval(() => {
        if (popupWindow.closed) {
          clearInterval(checkPopupClosed);
          handlePopupClose();
        }
      }, 1000);
    }
  };

  const handlePopupClose = () => {
    transactResult.mutate();
  };

  return (
    <>
      <div className="payverse-wrap">
        <div className="payverse">
          <PayverseDirectHeader />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              height: '70%',
            }}
          >
            <LoadingIndicator />
            <LoadingText />
          </div>
        </div>
      </div>
    </>
  );
};

export default DirectDebiaQRPage;
